"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supplyContractsCreateConfig = void 0;
exports.supplyContractsCreateConfig = {
    canCreateSupplyContracts: true,
    showCreateNewSupplyContractButton: true,
};
